export default __webpack_public_path__ + "static/media/906.02a2a9b6.png";